export default function () {
    Array.prototype.forEach.call(document.querySelectorAll('form.wpcf7-form'), function (form) {
        if (typeof MutationObserver === 'function') {
            var observer = new MutationObserver(function () {
                update.call(form);
            });
            observer.observe(form, {
                subtree: true,
                childList: true
            });
        }
    });

    function update() {
        Array.prototype.forEach.call(this.querySelectorAll('.wpcf7-form-control'), function (control) {
            var wrapper = control.closest('.form__field');
            if (!wrapper) {
                return;
            }
            var toggle = control.classList.contains('wpcf7-not-valid');
            if (toggle) {
                wrapper.classList.add('form__field--error');
            }
            else {
                wrapper.classList.remove('form__field--error');
            }
        });
    }
}